/**
 * Referral attribution that survives navigation. A fresh `?ref=` on the URL wins
 * and is persisted; otherwise we fall back to a previously-captured code so a
 * prospect who clicks a referral link, browses, and later returns to register
 * (without the query) is still attributed. Cleared on successful registration.
 */
const KEY = 'cs.ref';

export function captureReferralCode(): string | undefined {
  try {
    const fromUrl = new URLSearchParams(window.location.search).get('ref')?.trim();
    if (fromUrl) {
      localStorage.setItem(KEY, fromUrl);
      return fromUrl;
    }
    return localStorage.getItem(KEY)?.trim() || undefined;
  } catch {
    return undefined;
  }
}

export function clearReferralCode(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
